import { useEffect, useState } from "react"
import NewInfoFormat from "../../components/template/NewInfoFormat"
import Select from "react-select"
import api from "../../components/utils/api"
import EvaluationComparisonSummary from "./EvaluationComparisonSummary"
import EvaluationComparisonResult from "./EvaluationComparisonResult"

const EvaluaitonComparisonSelector = ({ idx, setValue, models, testset }) => {
    const [model, setModel] = useState()
    const [mergeRules, setMergeRules] = useState([])
    const [mergeRule, setMergeRule] = useState()

    useEffect(() => {
        if (testset) { setModel(null) }
    }, [testset])

    useEffect(() => {
        if (model && model.hasOwnProperty('value')) {
            setMergeRules([])
            setMergeRule(null)
            setValue(undefined)
            let cancelled = false
            const fetchMergeRules = async () => {
                try {
                    const res = await api.get(`/api/evaluation-comparison/evaluations/${testset.value}/general_models/${model.value}/valid-merge-rules`)
                    if (!cancelled) setMergeRules(res.data.valid_merge_rules.map(e => ({ label: e.name, value: e.id, general_model_id: model.value })))
                } catch (err) {
                    console.error(err)
                }
            }
            fetchMergeRules()
            return () => { cancelled = true }
        }
    }, [model, setValue, testset])

    useEffect(() => {
        if (mergeRule && mergeRule.hasOwnProperty('value')) {
            let cancelled = false
            const fetchEvaluation = async () => {
                try {
                    const res = await api.get(`/api/merge-rules/${mergeRule.value}/evaluations?&testset=${testset.value}`)
                    if (cancelled) return
                    const evaluation = res.data.evaluations[0]
                    setValue(evaluation && { ...evaluation, general_model_id: mergeRule.general_model_id, merge_rule_id: mergeRule.value })
                } catch (err) {
                    console.error(err)
                }
            }
            fetchEvaluation()
            return () => { cancelled = true }
        }
    }, [mergeRule, setValue, testset])

    return (
        <div>
            <NewInfoFormat label={`Model ${idx}`} contents={
                <Select
                    options={models}
                    value={model}
                    onChange={e => setModel(e)}
                />
            } />
            <NewInfoFormat label={`Merge Rule ${idx}`} contents={
                <Select
                    options={mergeRules}
                    value={mergeRule}
                    onChange={e => setMergeRule(e)}
                />
            } />
        </div>
    )
}

const EvaluaitonComparisonColumns = ({ testset }) => {
    const [models, setModels] = useState()
    const [evaluation1, setEvaluation1] = useState()
    const [evaluation2, setEvaluation2] = useState()

    useEffect(() => {
        setModels(undefined)
        setEvaluation1(undefined)
        setEvaluation2(undefined)
        if (testset.hasOwnProperty('value')) {
            let cancelled = false
            const fetchModels = async () => {
                try {
                    const res = await api.get(`/api/evaluation-comparison/evaluations/${testset.value}/general-models`)
                    if (!cancelled) setModels(res.data.general_models.map(e => ({ label: e.name, value: e.id, experiment_id: e.experiment_id })))
                } catch (err) {
                    console.error(err)
                }
            }
            fetchModels()
            return () => { cancelled = true }
        }
    }, [testset])

    return (
        <div>
            <div className="grid grid-cols-2 gap-2">
                {[
                    { setValue: setEvaluation1 },
                    { setValue: setEvaluation2 },
                ].map((e, i) => <EvaluaitonComparisonSelector idx={i + 1} setValue={e.setValue} models={models} testset={testset} key={i} />)}
            </div>
            <EvaluationComparisonSummary
                evaluation1={evaluation1}
                evaluation2={evaluation2}
            />
            <EvaluationComparisonResult
                evaluation1={evaluation1}
                evaluation2={evaluation2}
                testset={testset.value}
            />
        </div>
    )
}

export default EvaluaitonComparisonColumns